// GENERATED FILE — do not edit by hand.
// Written by scripts/generate-version.mjs on every build (npm prebuild + deploy).
// Format: v<appVersion>-A<angularMajor>[+<gitSha|timestamp>]
export const APP_VERSION = 'v0.1.0-A20';
export const APP_VERSION_FULL = 'v0.1.0-A20+d3bdbcf';
export const APP_BUILD_ID = 'd3bdbcf';
export const APP_RELEASE_DATE = '2026-10-24T23:19:50.787Z';
export const ANGULAR_MAJOR = 20;
